__turbopack_context__.v({
  "header": "Header-module-scss-module__P7cjuG__header",
  "header-container": "Header-module-scss-module__P7cjuG__header-container",
  "logo": "Header-module-scss-module__P7cjuG__logo",
  "logo-container": "Header-module-scss-module__P7cjuG__logo-container",
  "logo-desk": "Header-module-scss-module__P7cjuG__logo-desk",
  "logo-mobile": "Header-module-scss-module__P7cjuG__logo-mobile",
  "mobile-container": "Header-module-scss-module__P7cjuG__mobile-container",
  "mobile-cta-container": "Header-module-scss-module__P7cjuG__mobile-cta-container",
  "nav-close-button": "Header-module-scss-module__P7cjuG__nav-close-button",
  "nav-open-button": "Header-module-scss-module__P7cjuG__nav-open-button",
  "nav-toggle": "Header-module-scss-module__P7cjuG__nav-toggle",
  "navbar": "Header-module-scss-module__P7cjuG__navbar",
  "primary-navigation": "Header-module-scss-module__P7cjuG__primary-navigation",
  "title": "Header-module-scss-module__P7cjuG__title",
});
